import { Typography } from '@euler/app/components/typography';
import { kNavHeaderBlue } from '@euler/app/flows/settings/components/NavHeaderBg';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SafeHaptics } from '@euler/utils';
import { FC, memo, ReactNode } from 'react';
import { TouchableOpacity } from 'react-native';

export const TabBarItem: FC<{
  text: string;
  name: string;
  activeTabName: string;
  disabled?: boolean;
  icon: (size: number, color: string, active: boolean) => ReactNode;
  /** Optional overlay (e.g. unread badge) anchored to the icon's corner. */
  badge?: ReactNode;
  /** Defaults to `rpx(25)`. */
  iconSize?: number;
  /** Defaults to `rpx(11)`. */
  textSize?: number;
  onPress?: () => void;
}> = memo(
  ({
    text,
    name,
    activeTabName,
    icon,
    badge,
    disabled,
    iconSize,
    textSize,
    onPress,
  }) => {
    const { rpx } = useResponsiveContext();
    const size = iconSize ?? rpx(25);
    const active = name === activeTabName;
    const color = active ? kNavHeaderBlue : '#555';
    return (
      <TouchableOpacity
        css={`
          align-items: center;
          justify-content: center;
          flex: 1;
          opacity: ${disabled ? 0.5 : 1};
        `}
        onPress={() => {
          SafeHaptics.impact();
          if (active) return;
          onPress?.();
        }}
      >
        <Center
          css={`
            width: ${size}px;
            height: ${size}px;
          `}
        >
          {icon(size, color, active)}
          {badge}
        </Center>
        <Typography.Text
          size={textSize ?? rpx(11)}
          color={color}
          family={active ? 'bold' : 'regular'}
          lineHeight={rpx(20)}
        >
          {text}
        </Typography.Text>
      </TouchableOpacity>
    );
  },
);
